import Cookies from 'js-cookie';
import { Experiments, Buckets, UNASSIGNED } from '../constants';

export const isMyCarsReskinFixed = (): boolean => Cookies?.get?.(Experiments.MY_CARS_RESKIN) === Buckets.CONTROL_FIXED;

export const getMyCarsReskinBucket = (): string => Cookies?.get?.(Experiments.MY_CARS_RESKIN) || UNASSIGNED;
